
import { Component, Vue } from 'vue-property-decorator';
import { BCard } from 'bootstrap-vue';
import { IPlanificationPhaseProfileWorkDay } from '@/entity/planification/planification-phase-profile-work-day';
import { ICalendarHalfDay } from '@/entity/shared/calendar-day-picker';

@Component({
    components: {
        BCard
    }
})
export default class PeriodSelector extends Vue {
    inputStartDate: string = '';
    inputEndDate: string = '';

selectionMode: any = {
    value: 1,
    text: 'Toutes les semaines'
};

    weekInterval: number = 2;
    everyNthWeek: number = 1;
    monthInterval: number = 2;

    workDays: IPlanificationPhaseProfileWorkDay[] = [];

    selectionOptions = [
        { value: 1, text: 'Toutes les semaines' },
        { value: 2, text: 'Toutes les X semaines' },
        { value: 3, text: 'Tous les Y mois' },
        { value: 4, text: 'Toutes les Xᵉ semaines dans tous les Y mois' }
    ];

    weekdays = [
        { name: 'Lundi', code: 1, selected: false, morning: false, afternoon: false },
        { name: 'Mardi', code: 2, selected: false, morning: false, afternoon: false },
        { name: 'Mercredi', code: 3, selected: false, morning: false, afternoon: false },
        { name: 'Jeudi', code: 4, selected: false, morning: false, afternoon: false },
        { name: 'Vendredi', code: 5, selected: false, morning: false, afternoon: false }
    ];

    toggleDay(day) {
        day.selected = !day.selected;
    }

    private getFirstSelectedWeekdayDate(): Date | null {
        const start = new Date(this.inputStartDate);

        const selectedCodes = this.weekdays.filter((d) => d.selected).map((d) => Number(d.code));

        if (selectedCodes.length === 0) return null;

        // Create a date 7 days after start
        const end = new Date(start);
        end.setDate(end.getDate() + 7);

        // eslint-disable-next-line no-unmodified-loop-condition
        for (let current = new Date(start); current <= end; current.setDate(current.getDate() + 1)) {
            const jsDay = current.getDay();

            if (selectedCodes[0] === jsDay) {
                return new Date(current); // clone
            }
        }

        return null;
    }

    applySelection() {
        const start = new Date(this.inputStartDate);
        const end = new Date(this.inputEndDate);
        const selectedWorkDays: ICalendarHalfDay[] = [];

        const selectedWeekdays = this.weekdays.filter((d) => d.selected);

        if (selectedWeekdays.length === 0) return;

        const firstSelectedWeekdayDate = this.getFirstSelectedWeekdayDate();

        let current = new Date(start);

        while (current <= end) {
            const day = current.getDay();

            if (day === 0 || day === 6) {
                current.setDate(current.getDate() + 1);
                continue;
            }

            if (firstSelectedWeekdayDate && current < firstSelectedWeekdayDate) {
                current.setDate(current.getDate() + 1);
                continue;
            }

            const weekDay = selectedWeekdays.find((d) => d.code === day);

            if (weekDay) {
                // MODE 4 → Xᵉ week of month filter
                if (this.selectionMode === 4) {
                    const weekOfMonth = Math.ceil(current.getDate() / 7);
                    if (weekOfMonth !== this.everyNthWeek) {
                        current = this.incrementDate(current);
                        continue;
                    }
                }

                const currentDate = new Date(current);
                if (weekDay.morning) {
                    selectedWorkDays.push({
                        dayPartId: 1,
                        isSelected: true,
                        year: currentDate.getFullYear(),
                        day: currentDate.getDate(),
                        month: currentDate.getMonth()
                    });
                }

                if (weekDay.afternoon) {
                    selectedWorkDays.push({
                        dayPartId: 2,
                        isSelected: true,
                        year: currentDate.getFullYear(),
                        day: currentDate.getDate(),
                        month: currentDate.getMonth()
                    });
                }
            }

            current = this.incrementDate(current);
        }

        this.$emit('apply', selectedWorkDays);
    }

    private incrementDate(date: Date): Date {
        const next = new Date(date);

        switch (this.selectionMode) {
            case 1:
                next.setDate(next.getDate() + 1);
                break;

            case 2: // Every X weeks
                next.setDate(next.getDate() + 7 * (this.weekInterval - 1));

                break;

            case 3: // Every Y months
                next.setMonth(next.getMonth() + this.monthInterval - 1);

                break;

            case 4: // Xᵉ week in every Y months
                next.setDate(next.getDate() + 1);
                break;

            default:
                next.setDate(next.getDate() + 1);
        }

        return next;
    }
}
